//TODO Funktionen für Actions sind in jeder Strecke wiederholt, Refactoring möglich?
export const TARIF_CHECKED = 'TARIF_CHECKED';
export const ZUSATZOPTION_CHECKED = 'ZUSATZOPTION_CHECKED';
export const ZUSATZOPTION_UNCHECKED = 'ZUSATZOPTION_UNCHECKED';
export const OVERWRITE_ZUSATZOPTION = 'OVERWRITE_ZUSATZOPTION';
